
// -- Estados Solicitud
export const SOLICITUD_PENDIENTE_VALIDACION = 1;
export const SOLICITUD_APROBADA = 2;
export const SOLICITUD_APROBADA_CON_CAMBIOS = 3;
export const SOLICITUD_RECHAZADA = 4;

//-- Tipo de Solicitud
export const TIPO_SOLICITUD_INCLUSION = 1;
export const TIPO_SOLICITUD_MODIFICACION = 2;

// -- Tipos de Documentos
export const TIPO_ARCHIVO_IDENTIFICACION = 1;
export const TIPO_ARCHIVO_FORMULARIO = 2;
export const TIPO_ARCHIVO_PERSONERIA_JURIDICA=3;
export const TIPO_ARCHIVO_OTRO = 9;


//--CLASE TIPO PERSONA
export const TIPO_PERSONA_CLASE_FISICA = "F";
export const TIPO_PERSONA_CLASE_JURIDICA = "J";


//--- TIPOS AUTORIZACION
export const TIPOAUTORIZACION ={
    DEUDOR: 2,    
    ESPECIFICA : 3    
}
